export const NAME_PATTERN = /^[A-Za-z]+(?:[ '\u2019-]+[A-Za-z]+)*$/;

export const NAME_VALIDATION_MESSAGE =
  'Only letters, spaces, apostrophes and hyphens are allowed.';
